import React, {useContext} from 'react';
import {BridleContext} from './../BridleContextProvider';
import Toolbar from '../components/Toolbar';
import SectionInfo from './../components/SectionInfo';
import ProductImage from './../components/ProductImage';
import Buttons from './../components/Buttons';
import AttributeOptionsWithSwatch from '../components/AttributeOptionsWithSwatch';

const Color = () => {
    const {styles, options} = useContext(BridleContext);
    const colors = styles.attributeValues.filter(attr => {
        return attr.attributeName === 'Color';
    });

    return (
        <div className="bridle-page-content">
            <Toolbar pageName="Color" />
            <SectionInfo section="Color" page="1" />
            <ProductImage
                colorId={options.Color.ColorId}
                attributes={styles.attributeAvailabilities}
                altText={styles.name}
                defaultImage={styles.defaultImage}
            />
            <AttributeOptionsWithSwatch colors={colors} />
            <Buttons back="/" next="/crown" disableButton={!options.Color.ColorId} />
        </div>
    );
};

export default Color;
